import {flatTextPluralize, houseTextPluralize} from "./pluralize";

export const getLastHousePropertyText = (left: number) => (left === 1 ? "ostatni dom" : "jeden z ostatnich domów");

export const getLastHousePropertyWithCountingText = (left: number) => (left === 1 ? "ostatni dom" : `ostatnie ${left} ${houseTextPluralize(left)}`);

export const getLastFlatPropertyText = (left: number) => (left === 1 ? "ostatnie mieszkanie" : "jedno z ostatnich mieszkań");

export const getLastFlatPropertyWithCountingText = (left: number) => (left === 1 ? "ostatnie mieszkanie" : `ostatnie ${left} ${flatTextPluralize(left)}`);
import {flatTextPluralize, houseTextPluralize} from "./pluralize";

export const getLastHousePropertyText = (left: number) => (left === 1 ? "ostatni dom" : "jeden z ostatnich domów");

export const getLastHousePropertyWithCountingText = (left: number) => (left === 1 ? "ostatni dom" : `ostatnie ${left} ${houseTextPluralize(left)}`);

export const getLastFlatPropertyText = (left: number) => (left === 1 ? "ostatnie mieszkanie" : "jedno z ostatnich mieszkań");

export const getLastFlatPropertyWithCountingText = (left: number) => (left === 1 ? "ostatnie mieszkanie" : `ostatnie ${left} ${flatTextPluralize(left)}`);
